import { Theme } from "@cloudscape-design/components/theming";
import * as awsui from "@cloudscape-design/design-tokens";
import { createTheme, NextUIProvider, Text } from "@nextui-org/react"


// Cloudscape Theme
export const cloudScapeTheme: Theme = {
  tokens: {
    // Values are applied globally, except for visual contexts
    colorBackgroundLayoutMain: {
      // main page background
      light: "#f7f7f7",
      dark: "#202225"
    },
    colorBackgroundCellShaded: {
      // Bottom footer background
      light: "#f8f8f8",
      dark: "#101112"
    },
    colorBackgroundContainerContent: {
      // sid nav menu and container background
      light: "#fdfdff",
      dark: "#2f3136"
    },
    colorBackgroundContainerHeader: {
      // Page heading containers background
      // light: "#f0f0f0",
      dark: "#2f3136"
    },
    colorBackgroundHomeHeader: {
      // light: "#f0f0f0",
      // dark: "#36393e"
    },
    colorBackgroundInputDefault: {
      // light: "#f0f0f0",
      dark: "#1c1e21"
    },
    colorBackgroundDropdownItemDefault: {
      // light: "#f0f0f0",
      dark: "#060607"
    },
    // Shorter syntax to apply the same value for both light and dark mode
    // colorTextAccent: "#0073bb",
    // fontFamilyBase: "'Helvetica Neue', Roboto, Arial, sans-serif",
    // borderRadiusButton: "10px",
    // borderRadiusContainer: "4px"
  },
  contexts: {
    // Values for visual contexts. Unless specified, default values will be applied
    alert: {
      tokens: {
        // colorTextBodyDefault: "#129446"
      },
    },
    "top-navigation": {
      tokens: {
        colorBackgroundContainerContent: "#0c0d0e",
        colorBackgroundDropdownItemDefault: {
          // light:  "#101112",
          dark: "#101112"
        }
      },
    },
    header: {
      tokens: {
        colorBackgroundLayoutMain: "#131416",
      },
    },
    flashbar: {
      tokens: {
        // colorBackgroundLayoutMain: {
        //   light: "#060607",
        //   dark: "#060607"
        // },
      },
    },
  },
};




// NextUI Theme
export const nextUiTheme = createTheme({
  type: "light",
  theme: {
    colors: {
      primary: awsui.colorChartsBlue21000,
      primaryLight: awsui.colorChartsBlue2300,
      primaryLightHover: awsui.colorChartsBlue2300,
      primaryLightActive: awsui.colorChartsBlue2400,
      primaryLightContrast: awsui.colorChartsBlue2600,
      primaryBorder: awsui.colorChartsBlue2500,
      primaryBorderHover: awsui.colorChartsBlue2600,
      primarySolidHover: awsui.colorChartsBlue2700,
      primarySolidContrast: '$white',
      primaryShadow: awsui.colorChartsBlue2500,

      // secondary: awsui.colorChartsBlue2600,
      // secondaryLight: awsui.colorChartsBlue2300,
      // secondaryLightHover: awsui.colorChartsBlue2300,
      // secondaryLightActive: awsui.colorChartsBlue2400,
      // secondaryLightContrast: awsui.colorChartsBlue2600,
      // secondaryBorder: awsui.colorChartsBlue2500,
      // secondaryBorderHover: awsui.colorChartsBlue2600,
      // secondarySolidHover: awsui.colorChartsBlue2700,
      // secondarySolidContrast: '$white',
      // secondaryShadow: awsui.colorChartsBlue2500,


      gradient: 'linear-gradient(112deg, $blue100 -25%, $pink500 -10%, $purple500 80%)',

      link: awsui.colorTextLinkDefault,
      linkHover: awsui.colorTextLinkHover,
      navbarBackgroundColor: "$red",
      dropdownItemHoverBackground: awsui.colorBackgroundDropdownItemHover,
      
      backgroundContrast: "none", // popover background leaves a contrasting edge behind the dropdown menu,
      neutralLight: awsui.colorBackgroundDropdownItemHover,
      neutralLightActive: awsui.colorBackgroundDropdownItemHover,
      // foreground: awsui.colorTextBodyDefault,
      text: awsui.colorTextDropdownItemFilterMatch,
      backgroundAlpha: "none",

      // you can also create your own color
      colorBackgroundLayoutMain: awsui.colorBackgroundLayoutMain,
      colorBackgroundCellShaded: awsui.colorBackgroundCellShaded,
      colorBackgroundContainerContent: awsui.colorBackgroundContainerContent,
      colorBackgroundContainerHeader: awsui.colorBackgroundContainerHeader,
      colorBackgroundHomeHeader: awsui.colorBackgroundHomeHeader,
      colorBackgroundInputDefault: awsui.colorBackgroundInputDefault,
      colorBackgroundDropdownItemDefault: awsui.colorBackgroundDropdownItemDefault,
      colorTextAccent: awsui.colorTextAccent,
      fontFamilyBase: awsui.fontFamilyBase,
      borderRadiusButton: awsui.borderRadiusButton,
      borderRadiusContainer: awsui.borderRadiusContainer,
      colorTextBodyDefault: awsui.colorTextBodyDefault,
      colorTextBodySecondary: awsui.colorTextBodySecondary,
      colorTextHeadingSecondary: awsui.colorTextHeadingSecondary,
      colorBackgroundButtonPrimaryActive: awsui.colorBackgroundButtonPrimaryActive,
      colorBackgroundButtonPrimaryDefault: awsui.colorBackgroundButtonPrimaryDefault,
      colorBackgroundButtonPrimaryDisabled: awsui.colorBackgroundButtonPrimaryDisabled,
      colorBackgroundButtonPrimaryHover: awsui.colorBackgroundButtonPrimaryHover,
      colorBackgroundControlChecked: awsui.colorBackgroundControlChecked,
      colorBackgroundControlDefault: awsui.colorBackgroundControlDefault,


    },
    space: {},
    fonts: {}
  }
})